import type { BranchKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'

import { useNavigationParams } from '../../system/useNavigationParams'
import { useWorkspaceManagerContext } from '../../workspace/workspaceManagerContext'
import { useConciseChangesets } from '../changesets/useConciseChangesets'

export const useBranchKeyForChangeset = (
  changesetKey: Optional<string>,
): Optional<BranchKey> => {
  const { currentWorkspaceKey } = useWorkspaceManagerContext()
  const { server, branch } = useNavigationParams()
  const allChangesets = useConciseChangesets({
    workspaceKey: currentWorkspaceKey,
    branchKey: branch ? { server, name: branch } : undefined,
    shouldIncludeBaseConciseChangesets: true,
  })

  return changesetKey
    ? allChangesets.find((changeset) => changeset.changesetKey === changesetKey)
        ?.branchKey
    : undefined
}
